import { useContext } from 'react';
import { ModuleContext } from '../contexts/ModuleProvider';

export function useModules() {
  return useContext(ModuleContext);
}
